var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"resume-section p-3 p-lg-5 d-flex align-items-center",attrs:{"id":"interests"}},[_c('div',{staticClass:"w-100"},[_c('h2',{staticClass:"mb-5"},[_vm._v("Interests")]),_c('p',[_vm._v(_vm._s(_vm.interests.desc))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }